import axios from 'axios';

import { $api } from 'shared/api/api';

import type { GlobalCatalogItem } from '../../types/CatalogItemSchema';
import type { ExtendedAxiosRequestConfig } from 'shared/api/types';

export const fetchGlobalCatalogItemBySku = async (
    sku: string,
): Promise<GlobalCatalogItem | null> => {
    const config: ExtendedAxiosRequestConfig = {
        keysToNotConvert: ['specifications'],
    };
    try {
        const response = await $api.get<GlobalCatalogItem>(
            `/v1/catalogs/global-items/${encodeURIComponent(sku)}`,
            config,
        );
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
            return null;
        }
        throw error;
    }
};
